import ContactScreen from "./ContactScreen";

export default ContactScreen;
